import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'c-card-title',
  templateUrl: './card-title.component.html',
  styleUrls: ['./card-title.component.scss']
})
export class CardTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
